import React from 'react';

interface TalentLevelsProps {
  level: number;
  satisfaction: number;
}

const TalentLevels: React.FC<TalentLevelsProps> = ({ level, satisfaction }) => {
  return (
    <div className="talent-info-group">
      <div className="levels-container">
        <div className="level-item">
          <span className="level-title">Числовая оценка уровня развития:</span>
          <div className="level-indicator">
            <div className={`level-dot ${level ? 'active' : ''}`}>
              {level}
            </div>
          </div>
        </div>

        <div className="level-item">
          <span className="level-title">Уровень удовлетворенности от роли:</span>
          <div className="level-indicator">
            <div className={`satisfaction-dot ${satisfaction ? 'active' : ''}`}>
              {satisfaction}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalentLevels;
